import React from 'react';

import styles from './styles.scss';

export default class PageHeader extends React.Component {
    render() {
        return (
            <div className={ styles.header }>{ this.props.children }</div>
        )
    }
}